module.exports = __webpack_public_path__ + "assets/img/noticeIcon.91d8f9f3.png";